<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试场地管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">{{ pageDatas.examinationId ? '编辑' : '新建' }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form ref="pageDatas" label-width="100px" class="demo-ruleForm form-box" size="small"
              :rules="pageDatasRules" :model="pageDatas">
              <el-form-item label="场地名称" prop="areaName">
                <el-input v-model="pageDatas.areaName" placeholder="请输入场地名称"></el-input>
              </el-form-item>
              <el-form-item label="报到有效期(分)" prop="assignedValidMinute">
                <el-input type="number" v-model="pageDatas.assignedValidMinute" placeholder="请输入报到有效分钟"></el-input>
              </el-form-item>
              <el-form-item label="门禁标识" prop="gateSerial">
                <el-input type="textarea" rows="8" resize="none" style="width: 100%; max-width: 500px"
                          maxlength="200" show-word-limit placeholder="请输入门禁标识" v-model="pageDatas.gateSerial"></el-input>
              </el-form-item>
            </el-form>
            <div class="btn-box flexcc">
              <el-button class="bgc-bv" size="small" @click="cancelSave(2)">取 消</el-button>
              <el-button class="bgc-bv" size="small" @click="cancelSave(1)">确 定</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let editor = {};
export default {
  name: "examination_examAreaAddEdit",
  components: {},
  data() {
    return {
      // 页面数据
      pageDatas: {
        examAreaId: "", 
        areaName: "", // 
        gateSerial: "", // 
        assignedValidMinute: 0
      },
      // 页面数据 - 数据校验
      pageDatasRules: {
        areaName: [
          { required: true, trigger: "blur", message: "请输入考试场地名称" },
        ],
        gateSerial: [
          { required: true, trigger: "blur", message: "请输入门禁标识" },
        ]
      },
    };
  },
  created() {
    this.pageDatas.examAreaId = this.$route.query?.examAreaId ?? "";
    if (this.$route.query?.examAreaId) {
      this.getOnlineTestInfo();
    }
  },
  watch: {},
  computed: {},
  mounted() {
  },
  methods: {
    // 获取 - 考试详情

    getOnlineTestInfo() {
      this.$post("/biz/isec/exam-area/getInfo", { examAreaId: this.pageDatas.examAreaId }, 3000, true, 6)
        .then((res) => {
          this.pageDatas = {
            ...this.pageDatas,
            ...res.data
          }
          // editor.txt.html(res.data?.address ?? '');
        })
        .catch((err) => {
          return;
        });
    },
    // 取消&保存
    cancelSave(cType) {
      if (cType == 1) {
        this.$refs['pageDatas'].validate((valid) => {
          if (valid) {
            let url = '';
            if (this.pageDatas.examAreaId) {
              url = '/biz/isec/exam-area/modify'
            } else {
              url = '/biz/isec/exam-area/insert'
            }
            let cData = { ...this.pageDatas };
            this.$post(url, cData, 3000, true, 6)
              .then((res) => {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$router.back();
              })
              .catch((err) => {
                return;
              });
          }
        });
      } else {
        this.$router.back();
      }
    }
  },
};
</script>
<style lang="less" scoped>
.form-box {
  .el-input {
    width: 300px;
  }
}
</style>
  